import { render, staticRenderFns } from "./CommunityProfileMainData.vue?vue&type=template&id=8b08680a&scoped=true&"
import script from "./CommunityProfileMainData.vue?vue&type=script&lang=ts&"
export * from "./CommunityProfileMainData.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityProfileMainData.vue?vue&type=style&index=0&id=8b08680a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b08680a",
  null
  
)

export default component.exports